import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimEmailTemplate.Delete.IRequest;
type Response = Api.Core.ClaimEmailTemplate.Delete.IResponse;
type Headers = Api.Core.ClaimEmailTemplate.Delete.IHeaders;
const url = '/api/Management/ClaimEmailTemplate/:id';
export default async function claimEmailTemplateDeleteApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
